import React, { createContext, useState } from 'react';

// To store state data that will be gone on reload/navigate away
interface ISubmitContext {
    isSubmitting: boolean;
    isRedirecting: boolean;
    setIsSubmitting: (submitting: boolean) => void;
    setIsRedirecting: (isRedirecting: boolean) => void;
}

const SUBMIT_DEFAULTS: ISubmitContext = {
    isSubmitting: false,
    isRedirecting: false,
    setIsSubmitting: () => undefined,
    setIsRedirecting: () => undefined
};

const SubmitContext = createContext(SUBMIT_DEFAULTS);

const SubmitContextProvider = ({ children, override }: { children: React.ReactNode; override?: ISubmitContext }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isRedirecting, setIsRedirecting] = useState(false);

    return (
        <SubmitContext.Provider value={override ?? { isSubmitting, setIsSubmitting, isRedirecting, setIsRedirecting }}>
            {children}
        </SubmitContext.Provider>
    );
};

export { SubmitContext, SubmitContextProvider };
